export default {"src":"/_next/static/media/gold_heart.c15238ed.svg","height":21,"width":23,"blurWidth":0,"blurHeight":0};